import React, { useState } from "react";

// components
import { SatisfactionRadioGroup } from "./components/SatisfactionRadioGroup";
import { LongAnswer } from "../../components/LongAnswer";
import { ActionButton } from "../../designSystem/components/ActionButton";
import {surveyQuestions} from "./constant";
import {LoadingDialog} from "../../components/DialogLoading";

// services
import {updateSurveyByIdUser, updateSurveyByIdWorker} from "../../services/case";
import {TwoButtonDialog} from "../../designSystem/components/TwoButtonDialog";

interface SurveyProps {
  docId: string;
  onCloseDialog: () => void;
  userLineToken?: string;
  userToken?: string;
}

export const ApplicationSurvey = ({
  docId,
  onCloseDialog,
  userLineToken='',
  userToken=''
}: SurveyProps) => {
  const [surveyResponses, setSurveyResponses] = useState<{ [key: string]: string }>({});
  const [feedbackDescription, setFeedbackDescription] = useState<string>("");
  const [content, setContent] = useState<string>('form');

  const handleResponseChange = (questionId: string, value: string) => {
    setSurveyResponses((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!docId) {
      alert("無效的案件 ID");
      return;
    }
    setContent('loading');
    try {
      if (!userLineToken && !userToken) {
        return
      }
      if (userLineToken) {
        await updateSurveyByIdUser({
          token: userLineToken,
          id: docId,
          surveyResponses,
          feedbackDescription
        })
      } else {
        await updateSurveyByIdWorker({
          token: userToken,
          id: docId,
          surveyResponses,
          feedbackDescription
        })
      }
      setContent('success');
    } catch (error) {
      console.error("提交失敗:", error);
      setContent('form');
    }
  };

  if (content === 'loading') {
    return <LoadingDialog label={"載入中..."} />;
  }
  if (content === 'success') {
    return (
      <TwoButtonDialog
        type="success"
        title="已提交回饋"
        leftLabel="好的"
        leftOnClick={onCloseDialog}
        leftIconName="fa-check"
      />
    )
  }
  return (
    <div className="p-6">
      {surveyQuestions.map(({ id, text }) => (
        <div key={id} className="mb-4">
          <h2 className="text-lg font-semibold text-gray-800">{text}</h2>
          <SatisfactionRadioGroup name={id} value={surveyResponses[id] || ""} onChangeValue={(value) => handleResponseChange(id, value)} />
        </div>
      ))}

      <LongAnswer label="其他建議事項" value={feedbackDescription} onChange={(e) => setFeedbackDescription(e.target.value)} />

      {/* Submit Button */}
      <div className="mt-4">
        <ActionButton fullWidth label={"寫好送出"} iconName="fa-paper-plane" onClick={handleSubmit} />
      </div>
    </div>
  );
};
